export default "__VITE_ASSET__cfc80776__"